import { Amplify } from "aws-amplify";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: "eu-central-1_u3BQqX2P4",
      userPoolClientId: "24cff3dv1k1vs7dqp3447o1p0c",
      loginWith: {
        email: true
      }
    }
  }
});
